{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/tab-panel",
	"title": "Tab Panel",
	"description": "Content for a tab in a tabbed interface.",
	"category": "design",
	"textdomain": "default",
	"attributes": {
		"label": {
			"type": "string",
			"default": ""
		}
	},
	"parent": [ "core/tab-panels" ],
	"usesContext": [ "core/tabs-id" ],
	"supports": {
		"anchor": true,
		"background": {
			"backgroundImage": true,
			"backgroundSize": true,
			"gradient": true,
			"__experimentalDefaultControls": {
				"backgroundImage": true,
				"gradient": true
			}
		},
		"html": false,
		"color": {
			"background": true,
			"button": true,
			"heading": true,
			"link": true,
			"text": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"layout": true,
		"shadow": true,
		"spacing": {
			"blockGap": true,
			"padding": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true,
				"__experimentalFontFamily": true
			}
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true
		},
		"visibility": false
	},
	"providesContext": {
		"core/tab-label": "label"
	},
	"style": "wp-block-tab-panel"
}
